import { Answer } from 'types/answers'

export function preserveSignalContextForBatchedAnswer(
    answer: Answer,
    cached: Answer | null | undefined,
): Answer {
    if (!cached?.signal_quest_id) return answer
    if (String(cached.signal_quest_id) === String(answer.signal_quest_id ?? '')) return answer

    const preserved = {
        ...answer,
        signal_quest_id: cached.signal_quest_id,
    }
    if (cached.upvalues_enabled !== undefined) preserved.upvalues_enabled = cached.upvalues_enabled
    if (cached.free_reactions_enabled !== undefined) {
        preserved.free_reactions_enabled = cached.free_reactions_enabled
    }
    return preserved
}
